import { useMemo, useRef } from 'react';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { buildUrl, parseUrl } from 'hub-http/helpers/url';
import { getFullUrl } from 'hubspot-url-utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const url = path => {
  const isQAProxy = window.location.hostname.indexOf('wthubspot') >= 0;
  const isQA = enviro.isQa() || isQAProxy;
  const baseUrl = getFullUrl('app', {
    envOverride: isQA ? 'qa' : 'prod'
  });
  const {
    protocol,
    hostname
  } = parseUrl(baseUrl);
  return buildUrl({
    protocol,
    hostname,
    path
  });
};
const AssignSeatButtonBase = ({
  apiName,
  children,
  uiButtonProps,
  trackingData,
  upgradeConfig,
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId
}) => {
  const trackingProperties = useMemo(() => getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig,
    sourceKey: 'ASSIGN_SEAT'
  }), [apiName, trackingData, upgradeConfig]);
  const internalRef = useRef(null);
  const buttonRef = (uiButtonProps === null || uiButtonProps === void 0 ? void 0 : uiButtonProps.buttonRef) || internalRef;
  useIntersectionObserver({
    targetRef: buttonRef,
    onIntersect: () => {
      track('interaction', Object.assign({
        action: 'viewed assign seat'
      }, trackingProperties));
    }
  });
  const trackClick = () => {
    track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, trackingProperties));
    track('interaction', Object.assign({
      action: 'clicked assign seat'
    }, trackingProperties));
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    href: url(`/settings/${PortalIdParser.get()}/users/seats`),
    external: true,
    onClick: trackClick,
    truncate: true,
    truncateStringProps: {
      justifyContent: 'center'
    }
  }, uiButtonProps, {
    // TODO: remove cast when on React 19 types (HubSpotEngineering/fefw#73)
    buttonRef: buttonRef,
    "data-test-id": dataTestId,
    "data-selenium-id": dataSeleniumId,
    children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.buttons.assignSeat"
    })
  }));
};
export const AssignSeatButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.ASSIGN_SEAT_BUTTON,
  children: /*#__PURE__*/_jsx(AssignSeatButtonBase, Object.assign({}, props))
});